export const text = {
    notesOne:'Notification Templates module will list all notifications on this page.',
    notesTwo:'Administrator can edit any Notification template.',
}